<template>
  <el-container>
    <el-header>
      <Header>
        <MenuBar />
        <User />
      </Header>
    </el-header>
    <el-main v-bind:class="pageName">
      <slot></slot>
    </el-main>
    <el-footer>
      <Footer />
    </el-footer>
  </el-container>
</template>

<script>
import Header from '@/components/organisms/Header.vue'
import MenuBar from '@/components/organisms/MenuBar.vue'
import User from '@/components/organisms/User.vue'
import Footer from '@/components/organisms/Footer.vue'
export default {
  components: {
    Header,
    MenuBar,
    User,
    Footer
  },
  props: {
    pageName: { type: String, required: true }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
#app {
  > .el-container {
    --page-header-top: 0;
    --page-header-height: 0;
    header.el-header {
      position: sticky;
      padding-top: 0.3rem;
      padding-bottom: 0.3rem;
      top: 0;
      height: var(--header-height) !important;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 2000;
      &::before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 0.3rem;
        background-color: #DFE3E1;
        z-index: 2000;
      }
      &::after {
        content: "";
        position: fixed;
        top: calc(var(--header-height) - 0.3rem);
        left: 0;
        right: 0;
        height: 0.3rem;
        background-color: #DFE3E1;
        z-index: 2000;
      }
    }
    main.el-main {
      min-height: calc(100vh - var(--header-height) - var(--footer-height));
      &.el-main {
        overflow-x: initial;
        overflow-y: initial;
        .el-table {
          overflow-x: initial;
          overflow-y: initial;
        }
        .el-table td, th {
          text-align: center;
        }
        .el-table th>.cell {
          // padding-left: 20px;
          padding-left: 15px;
        }
      }
    }
    footer.el-footer {
      position: sticky;
      // bottom: 0.6rem;
      bottom: 0;
      height: var(--footer-height) !important;
      z-index: 2000;
      background-color: var(--primary-background-color);
    }
    &.is-pageHeader{
      &::before {
        content: "";
        position: fixed;
        top: var(--page-header-top);
        left: 0;
        right: 0;
        height: var(--page-header-height);;
        background-color: #F5F5F5;
        z-index: 0;
      }
    }
    &::after {
      content: "";
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      // height: calc(var(--footer-height) + 1.2rem) !important;
      height: var(--footer-height) !important;
      background-color: var(--primary-color);
      z-index: 1999;
    }
  }
}
div.el-loading-mask {
  background-color: rgba($color: #000000, $alpha: 0.6);
}
.el-input.is-disabled .el-input__inner{
  color: #808080 !important
}
</style>
